import Label from "../helpers/forms/label";

function initInputLabels() {
    const inputs = document.querySelectorAll('.js-input');

    if (inputs.length > 0) {
        inputs.forEach((input) => {
            // eslint-disable-next-line no-new
            new Label(input);
        });
    }
}

initInputLabels();
